import { Icon } from "web/components"

export default function EventSubjectCreated({ event }) {
  const creatorDescription =
    event.creator === null ? "Created" : `Created by ${event.creator}`

  return (
    <>
      <Icon name="inbox-arrow-down" outline="true" />{" "}
      <span>{creatorDescription}</span>
    </>
  )
}
